module.exports = __webpack_public_path__ + "static/media/gabrielRauch.0f61bee3.jpeg";